<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container">
    <div :style="style.header">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseHeader',
    inheritAttrs: false,
    props: {
      styleConfig: {
        type: Object,
        required: false,
        default: () => {}
      },
      truncate: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            minWidth: this.truncate ? 0 : 'none', /* minWidth must be overwritten to enable truncate */
            width: this.truncate ? '100%' : 'none',
          },
          header: {
            ...(this.truncate ? {
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            } : {}),
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.container,
        this.styleConfig.container,
      );

      Object.assign(
        this.style.header,
        this.styleConfig.header,
      );
    },
  };
</script>
